import { default as indexDzLhnJDtP1Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/about-us/index.vue?macro=true";
import { default as _91slug_93qHkJUcqSffMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/blog/[slug].vue?macro=true";
import { default as index9DkPN9C2iHMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/blog/index.vue?macro=true";
import { default as _91id_93eyFmm6vG0CMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/booking/[id].vue?macro=true";
import { default as _91id_93kNvH6wAFWBMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/brand-ambassador/[id].vue?macro=true";
import { default as index7vdR2twRE1Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/cart/index.vue?macro=true";
import { default as _91id_93Cahbe8Zhr0Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/group-trips/[id].vue?macro=true";
import { default as indexGeBA2NgZHHMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/group-trips/index.vue?macro=true";
import { default as index186SJVES4CMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/index.vue?macro=true";
import { default as index8QmDt2BEzbMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/login/index.vue?macro=true";
import { default as monthly_45draw10Al2kTmO0Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/monthly-draw.vue?macro=true";
import { default as paymentcpeAa8CgwGMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/payment.vue?macro=true";
import { default as _91id_93hP1nQTzSWxMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/private-trips/[id].vue?macro=true";
import { default as indexauqISZ7iNkMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/private-trips/index.vue?macro=true";
import { default as indexaPlXGyi8BYMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/index.vue?macro=true";
import { default as index5FtlC9dR8CMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/loyalty-coupons/index.vue?macro=true";
import { default as indexdkSb7yRiJrMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/subscription-plans/index.vue?macro=true";
import { default as indexcLULQ2J86jMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/upcoming-bookings/index.vue?macro=true";
import { default as indexeEYdMuluBCMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/register/index.vue?macro=true";
import { default as indexXK16pqZCAKMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/index.vue?macro=true";
import { default as otpWksapw3o3zMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/otp.vue?macro=true";
import { default as reset_45passwordvgRarEitwEMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/reset-password.vue?macro=true";
import { default as Best_45Price_45GuaranteeMGDEaAcIorMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Best-Price-Guarantee.vue?macro=true";
import { default as Cookie_45PolicyUT0f8UpgIgMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Cookie-Policy.vue?macro=true";
import { default as General_45Terms_45of_45UsetSq9TUrDqwMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/General-Terms-of-Use.vue?macro=true";
import { default as Privacy_45policyXYuVKulBLyMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Privacy-policy.vue?macro=true";
import { default as rulesYW0sRJ4e6fMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/rules.vue?macro=true";
import { default as _91search_93OaOx9YjzXFMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/search-page/[search].vue?macro=true";
import { default as _91id_939yD6JpMfbBMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/store/[id].vue?macro=true";
import { default as indexHs7grvgnPkMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/store/index.vue?macro=true";
import { default as cancel6X8epyHhy6Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/cancel.vue?macro=true";
import { default as indexik29N5NFy5Meta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/index.vue?macro=true";
import { default as successfXAFTz87wyMeta } from "/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/success.vue?macro=true";
export default [
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/about-us/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/blog/index.vue")
  },
  {
    name: "booking-id",
    path: "/booking/:id()",
    meta: _91id_93eyFmm6vG0CMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/booking/[id].vue")
  },
  {
    name: "brand-ambassador-id",
    path: "/brand-ambassador/:id()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/brand-ambassador/[id].vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: index7vdR2twRE1Meta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/cart/index.vue")
  },
  {
    name: "group-trips-id",
    path: "/group-trips/:id()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/group-trips/[id].vue")
  },
  {
    name: "group-trips",
    path: "/group-trips",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/group-trips/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/login/index.vue")
  },
  {
    name: "monthly-draw",
    path: "/monthly-draw",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/monthly-draw.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/payment.vue")
  },
  {
    name: "private-trips-id",
    path: "/private-trips/:id()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/private-trips/[id].vue")
  },
  {
    name: "private-trips",
    path: "/private-trips",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/private-trips/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexaPlXGyi8BYMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/index.vue")
  },
  {
    name: "profile-loyalty-coupons",
    path: "/profile/loyalty-coupons",
    meta: index5FtlC9dR8CMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/loyalty-coupons/index.vue")
  },
  {
    name: "profile-subscription-plans",
    path: "/profile/subscription-plans",
    meta: indexdkSb7yRiJrMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/subscription-plans/index.vue")
  },
  {
    name: "profile-upcoming-bookings",
    path: "/profile/upcoming-bookings",
    meta: indexcLULQ2J86jMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/profile/upcoming-bookings/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/register/index.vue")
  },
  {
    name: "rest",
    path: "/rest",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/index.vue")
  },
  {
    name: "rest-otp",
    path: "/rest/otp",
    meta: otpWksapw3o3zMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/otp.vue")
  },
  {
    name: "rest-reset-password",
    path: "/rest/reset-password",
    meta: reset_45passwordvgRarEitwEMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rest/reset-password.vue")
  },
  {
    name: "rules",
    path: "/rules",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rules.vue"),
    children: [
  {
    name: "rules-Best-Price-Guarantee",
    path: "Best-Price-Guarantee",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Best-Price-Guarantee.vue")
  },
  {
    name: "rules-Cookie-Policy",
    path: "Cookie-Policy",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Cookie-Policy.vue")
  },
  {
    name: "rules-General-Terms-of-Use",
    path: "General-Terms-of-Use",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/General-Terms-of-Use.vue")
  },
  {
    name: "rules-Privacy-policy",
    path: "Privacy-policy",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/rules/Privacy-policy.vue")
  }
]
  },
  {
    name: "search-page-search",
    path: "/search-page/:search()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/search-page/[search].vue")
  },
  {
    name: "store-id",
    path: "/store/:id()",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/store/[id].vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/store/index.vue")
  },
  {
    name: "subscription-payment-cancel",
    path: "/subscription-payment/cancel",
    meta: cancel6X8epyHhy6Meta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/cancel.vue")
  },
  {
    name: "subscription-payment",
    path: "/subscription-payment",
    meta: indexik29N5NFy5Meta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/index.vue")
  },
  {
    name: "subscription-payment-success",
    path: "/subscription-payment/success",
    meta: successfXAFTz87wyMeta || {},
    component: () => import("/Users/infamus/Projects/compass_app/compass_frontend/pages/subscription-payment/success.vue")
  }
]